const getDefaultState = () => {
    return {
        name: '',
        emote: '',
        powerClass: '',
        level: '',
        type: 'atwill',
        typeName: '',
        keywords: '',
        actionType: '',     
        range: '',
        requirement: '', 
        trigger: '',        
        beforeSpecial: '',
        beforeEffect: '', 
        target: '',
        effect: '',               
        special: '',
    };
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        resetState: (state) => Object.assign(state, getDefaultState()),
        setName: (state, value) => state.name = value,
        setEmote: (state, value) => state.emote = value,
        setPowerClass: (state, value) => state.powerClass = value,
        setLevel: (state, value) => state.level = value,
        setType: (state, value) => state.type = value,                
        setKeywords: (state, value) => state.keywords = value,
        setTypeName: (state, value) => state.typeName = value,
        setActionType: (state, value) => state.actionType = value,
        setRange: (state, value) => state.range = value,
        setRequirement: (state, value) => state.requirement = value,   
        setTrigger: (state, value) => state.trigger = value,               
        setBeforeSpecial: (state, value) => state.beforeSpecial = value,
        setBeforeEffect: (state, value) => state.beforeEffect = value,  
        setTarget: (state, value) => state.target = value,
        setEffect: (state, value) => state.effect = value,        
        setSpecial: (state, value) => state.special = value,
    },
}